import React from "react";
import { AuthHeaderWrapper } from "./style";
import newLoginLogo from "@/assets/newLoginLogo.svg";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function AuthHeader() {
	const { pathname } = useLocation();
	const { i18n } = useTranslation();
	// 현재 창 너비 추적용
	const [innerWidth, setInnerWidth] = React.useState(window.innerWidth);
	const [anchorLanguageEl, setAnchorLanguageEl] = React.useState<null | HTMLElement>(
		null,
	);
	const languageMenuOpen: boolean | undefined = Boolean(anchorLanguageEl);

	const handleLanguageClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorLanguageEl(event.currentTarget);
	};

	const handleLanguageChange = (language: string) => {
		localStorage.setItem("language", language);
		i18n.changeLanguage(language);
	};

	const handleLanguageClose = () => {
		setAnchorLanguageEl(null);
	};
	React.useEffect(() => {
		const resizeListener = () => {
			setInnerWidth(window.innerWidth);
		};
		window.addEventListener("resize", resizeListener);
	});
	return (
		<AuthHeaderWrapper>
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					width: `${
						pathname === "/auth/login" && innerWidth >= 1030
							? "calc(100% - 460px)"
							: "100%"
					}`,
				}}
			>
				<img width={160} src={newLoginLogo} alt="사진없음" />
				<div>
					<IconButton
						id="language-button"
						aria-controls={languageMenuOpen ? "language-menu" : ""}
						aria-haspopup="true"
						aria-expanded={languageMenuOpen}
						onClick={handleLanguageClick}
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="34"
							height="34"
							viewBox="0 0 34 34"
							fill="none"
						>
							<path
								d="M17 28C15.46 28 14.0208 27.7113 12.6825 27.1337C11.3442 26.5562 10.18 25.7725 9.19 24.7825C8.2 23.7925 7.42083 22.6238 6.8525 21.2762C6.28417 19.9288 6 18.485 6 16.945C6 15.405 6.28417 13.9704 6.8525 12.6413C7.42083 11.3121 8.2 10.1525 9.19 9.1625C10.18 8.1725 11.3442 7.39792 12.6825 6.83875C14.0208 6.27958 15.46 6 17 6C18.54 6 19.9792 6.27958 21.3175 6.83875C22.6558 7.39792 23.82 8.1725 24.81 9.1625C25.8 10.1525 26.5792 11.3121 27.1475 12.6413C27.7158 13.9704 28 15.405 28 16.945C28 18.485 27.7158 19.9288 27.1475 21.2762C26.5792 22.6238 25.8 23.7925 24.81 24.7825C23.82 25.7725 22.6558 26.5562 21.3175 27.1337C19.9792 27.7113 18.54 28 17 28ZM17 26.405C17.6417 25.745 18.1779 24.9888 18.6088 24.1362C19.0396 23.2838 19.3925 22.2708 19.6675 21.0975H14.36C14.6167 22.1975 14.9604 23.1875 15.3912 24.0675C15.8221 24.9475 16.3583 25.7267 17 26.405ZM14.6625 26.075C14.2042 25.3783 13.81 24.6267 13.48 23.82C13.15 23.0133 12.875 22.1058 12.655 21.0975H8.53C9.22667 22.3992 10.0333 23.4212 10.95 24.1637C11.8667 24.9062 13.1042 25.5433 14.6625 26.075ZM19.365 26.0475C20.685 25.6258 21.8721 24.9933 22.9263 24.15C23.9804 23.3067 24.8283 22.2892 25.47 21.0975H21.3725C21.1342 22.0875 20.8546 22.9858 20.5337 23.7925C20.2129 24.5992 19.8233 25.3508 19.365 26.0475ZM7.98 19.4475H12.3525C12.2975 18.9525 12.2654 18.5079 12.2562 18.1137C12.2471 17.7196 12.2425 17.33 12.2425 16.945C12.2425 16.4867 12.2517 16.0787 12.27 15.7212C12.2883 15.3637 12.325 14.965 12.38 14.525H7.98C7.85167 14.965 7.76458 15.3592 7.71875 15.7075C7.67292 16.0558 7.65 16.4683 7.65 16.945C7.65 17.4217 7.67292 17.8479 7.71875 18.2238C7.76458 18.5996 7.85167 19.0075 7.98 19.4475ZM14.0575 19.4475H19.97C20.0433 18.8792 20.0892 18.4163 20.1075 18.0588C20.1258 17.7013 20.135 17.33 20.135 16.945C20.135 16.5783 20.1258 16.2254 20.1075 15.8862C20.0892 15.5471 20.0433 15.0933 19.97 14.525H14.0575C13.9842 15.0933 13.9383 15.5471 13.92 15.8862C13.9017 16.2254 13.8925 16.5783 13.8925 16.945C13.8925 17.33 13.9017 17.7013 13.92 18.0588C13.9383 18.4163 13.9842 18.8792 14.0575 19.4475ZM21.62 19.4475H26.02C26.1483 19.0075 26.2354 18.5996 26.2812 18.2238C26.3271 17.8479 26.35 17.4217 26.35 16.945C26.35 16.4683 26.3271 16.0558 26.2812 15.7075C26.2354 15.3592 26.1483 14.965 26.02 14.525H21.6475C21.7025 15.1667 21.7392 15.6571 21.7575 15.9963C21.7758 16.3354 21.785 16.6517 21.785 16.945C21.785 17.3483 21.7712 17.7288 21.7437 18.0863C21.7162 18.4438 21.675 18.8975 21.62 19.4475ZM21.345 12.875H25.47C24.865 11.61 24.0354 10.5558 22.9813 9.7125C21.9271 8.86917 20.7125 8.27333 19.3375 7.925C19.7958 8.60333 20.1854 9.33667 20.5063 10.125C20.8271 10.9133 21.1067 11.83 21.345 12.875ZM14.36 12.875H19.695C19.4933 11.9033 19.1542 10.9637 18.6775 10.0563C18.2008 9.14875 17.6417 8.34667 17 7.65C16.4133 8.145 15.9183 8.79583 15.515 9.6025C15.1117 10.4092 14.7267 11.5 14.36 12.875ZM8.53 12.875H12.6825C12.8842 11.885 13.1408 11.0004 13.4525 10.2213C13.7642 9.44208 14.1583 8.68583 14.635 7.9525C13.26 8.30083 12.0592 8.8875 11.0325 9.7125C10.0058 10.5375 9.17167 11.5917 8.53 12.875Z"
								fill="black"
							/>
						</svg>
						<span style={{ fontSize: "16px", color: "black" }}>
							{i18n.language === "ko" && "한국어"}
							{i18n.language === "en" && "English"}
						</span>
					</IconButton>
				</div>
				<Menu
					id="basic-menu"
					anchorEl={anchorLanguageEl}
					open={languageMenuOpen}
					onClose={handleLanguageClose}
					MenuListProps={{
						"aria-labelledby": "language-button",
					}}
				>
					<MenuItem onClick={() => handleLanguageChange("ko")}>한국어</MenuItem>
					<MenuItem onClick={() => handleLanguageChange("en")}>
						English
					</MenuItem>
				</Menu>
			</div>
		</AuthHeaderWrapper>
	);
}
